import 'intersection-observer'

export default class StickObserver{
	constructor(stickContainer) {
	    this.subs = new Map()
		this.timer = null
		this.topLocker = false
		this.downLocker = false
		this.stickContainer = stickContainer
	}
	
	observe(watcher){
		const {el} = watcher
		this.subs.set(el.id, watcher)
	}
	
	action(){
		for(let eleId of this.subs.keys()){
			const watcher = this.subs.get(eleId)
			const {top} = watcher.el.getClientRects()[0]
			if(top <= 0 && !this.topLocker){
				this.stickContainer[watcher.position].appendChild(watcher.el.children[0])
				this.topLocker = true
				this.downLocker = false
			}
			if(top > watcher.height){
				if(this.stickContainer[watcher.position] && this.stickContainer[watcher.position].children.length > 0){
					if(!this.downLocker){
						watcher.el.appendChild(this.stickContainer[watcher.position].children[0])
						this.downLocker = true	
						this.topLocker = false
					}
				}
			}
		}
	}
}

export class Watcher{
	constructor(el, height, position = 'top') {
	    this.el = el
		this.height = height
		this.position = position
	}
}